import {Component, OnInit} from '@angular/core';
import {ControlContainer, UntypedFormGroup as FormGroup} from "@angular/forms";
import {DialogRef} from "@fundamental-ngx/core/dialog";
import {OperationalScenario, LandscapesKeyToDisplayName} from "../../shared/WizardHelpers";
import {STEP_SETUP_FORM_CONTROLS, STEP_SETUP_FORM_GROUPS} from "../unified-step-setup/unified-step-setup.component";
import {PAYLOAD_FORM_CONTROLS, PAYLOAD_FORM_GROUPS} from "../unified-create-application-dialog.component";
import {Const} from "../../../../../core/helpers/Const";

@Component({
    selector: 'app-unified-step-review',
    templateUrl: './unified-step-review.component.html',
    styleUrls: ['./unified-step-review.component.scss'],
    standalone: false
})
export class UnifiedStepReviewComponent implements OnInit {
    readonly OperationalScenario = OperationalScenario;
    readonly STEP_SETUP_FORM_GROUPS = STEP_SETUP_FORM_GROUPS;
    readonly STEP_SETUP_FORM_CONTROLS = STEP_SETUP_FORM_CONTROLS;
    readonly PAYLOAD_FORM_GROUPS = PAYLOAD_FORM_GROUPS;
    readonly PAYLOAD_FORM_CONTROLS = PAYLOAD_FORM_CONTROLS;
    readonly Const = Const;
    public form: FormGroup;
    public path: string;

    readonly CUSTOM_VALIDATION_ERRORS = {
        RESOURCE_TYPE_DEFINITION: {
            GROUP: "Invalid input. The value can contain only lowercase alphabetical letters (a-z), numbers (0-9), hyphens (-), and periods (.). It must start and end with a lowercase letter or number.",
            VERSION: "Invalid input. The value can contain only lowercase alphabetical letters (a-z), numbers (0-9), and hyphens (-). It must start with a lowercase letter, and end with either a lowercase letter or number.",
            TYPE: "Invalid input. The value can contain only lowercase and uppercase alphabetical letters (a-z, A-Z). It must start with an uppercase letter (A-Z).",
            SINGULAR_PLURAL: "Invalid input. The value can contain only lowercase alphabetical letters (a-z)."
        },
        SPFIAPP: {
            ENDPOINT: "Invalid URL format. The value must start with https:// and can contain any combination of characters after that."
        }
    };

    constructor(private controlContainer: ControlContainer, private dialogRef: DialogRef) { }

    ngOnInit(): void {
        this.form = <FormGroup>this.controlContainer.control;
        this.path = this.dialogRef.data.path;
    }
}
